module.exports = __webpack_public_path__ + "img/clipboard_notes.b9f06962.svg";